import { styled } from '@chronosphereio/chrono-ui';
import { Virtuoso } from 'react-virtuoso';
import { ListLegendItem, ListLegendItemProps } from './ListLegendItem';
import { isLegendItemSelected, LegendItem, SelectedLegendItemState } from './legend-model';

export interface StackedListLegendProps {
  items: LegendItem[];
  height: number;
  width: number;
  selectedItems: SelectedLegendItemState;
  onLegendItemClick: ListLegendItemProps['onClick'];
  onLegendCheckboxClick: ListLegendItemProps['onCheckboxChange'];
  onItemMouseOver: ListLegendItemProps['onMouseOver'];
  onItemMouseOut: ListLegendItemProps['onMouseOut'];
  disableListLegendItemTruncation: ListLegendItemProps['disableListLegendItemTruncation'];
}

/**
 * StackedListLegend is used when legend.position is 'right' since legend items are
 * stacked. It is also used for `bottom` positioned legends when there are a
 * large number of items because it is virtualized and easier to visually scan
 * large numbers of items when there is a single item per row.
 */
export function StackedListLegend({
  items,
  height,
  width,
  selectedItems,
  onLegendItemClick,
  onLegendCheckboxClick,
  onItemMouseOver,
  onItemMouseOut,
  disableListLegendItemTruncation,
}: StackedListLegendProps) {
  return (
    <Virtuoso
      style={{ height, width }}
      data={items}
      itemContent={(index, item) => {
        return (
          <StackListLegendItem
            key={item.id}
            item={item}
            index={index}
            isSelected={isLegendItemSelected(item, selectedItems)}
            onClick={onLegendItemClick}
            onCheckboxChange={onLegendCheckboxClick}
            onMouseOver={onItemMouseOver}
            onMouseOut={onItemMouseOut}
            disableListLegendItemTruncation={disableListLegendItemTruncation}
          />
        );
      }}
      role="list"
    />
  );
}

const StackListLegendItem = styled(ListLegendItem)(({ theme }) => {
  return {
    width: '100%',
    paddingRight: theme.spacing(0.5),
    wordBreak: 'break-word',
    overflow: 'hidden',
  };
});
